module.exports = __webpack_public_path__ + "img/emoji_97.16405f46.png";